enum AssetTagRelationshipsConstants {
  ADD_ASSET_TAG_RELATIONSHIPS = '@AssetTags/ADD_ASSET_TAG_RELATIONSHIPS',
  ADD_ASSET_TAG_RELATIONSHIPS_REQUEST = '@AssetTags/ADD_ASSET_TAG_RELATIONSHIPS_REQUEST',
  ADD_ASSET_TAG_RELATIONSHIPS_REQUEST_SUCCESS = '@AssetTags/ADD_ASSET_TAG_RELATIONSHIPS_REQUEST_SUCCESS',
  ADD_ASSET_TAG_RELATIONSHIPS_REQUEST_ERROR = '@AssetTags/ADD_ASSET_TAG_RELATIONSHIPS_REQUEST_ERROR',

  REMOVE_ASSET_TAG_RELATIONSHIPS = '@AssetTags/REMOVE_ASSET_TAG_RELATIONSHIPS',
  REMOVE_ASSET_TAG_RELATIONSHIPS_REQUEST = '@AssetTags/REMOVE_ASSET_TAG_RELATIONSHIPS_REQUEST',
  REMOVE_ASSET_TAG_RELATIONSHIPS_REQUEST_SUCCESS = '@AssetTags/REMOVE_ASSET_TAG_RELATIONSHIPS_REQUEST_SUCCESS',
  REMOVE_ASSET_TAG_RELATIONSHIPS_REQUEST_ERROR = '@AssetTags/REMOVE_ASSET_TAG_RELATIONSHIPS_REQUEST_ERROR',
}

export default AssetTagRelationshipsConstants;
